export const shirtSizes = {
    's': 'S',
    'm': 'M',
    'l': 'L',
    'xl': 'XL',
}

export const departments = {
    'w1': 'W-1',
    'w8': 'W-8',
    'w0': 'Inny',
}

export const allDepartments = {
    'w1': 'W-1',
    'w2': 'W-2',
    'w3': 'W-3',
    'w4': 'W-4',
    'w5': 'W-5',
    'w6': 'W-6',
    'w7': 'W-7',
    'w8': 'W-8',
    'w9': 'W-9',
    'w10': 'W-10',
    'w11': 'W-11',
    'w12': 'W-12',
    'w13': 'W-13'
}

export const transportHours = {
    '11': '11:00',
    '14': '14:00',
    '0': 'Transport własny'
}



// WEBPACK FOOTER //
// ./src/modules/User/const.js